/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { DEVICE, IDENTITY_KEY_NAME } from '@/constants';
import { category } from '@/api';
import {
  callNativeFunction, nativeFunction,
  OS, getIdentity,
} from '@/utils/detectDevice';
import VERSION_NAME, { greaterAndEqualThan } from '@/utils/historyVersion';
import { soundsPath } from '@/utils/sounds';
import DownLoad from '@/components/Download';
import './style.less';

@withRouter
class Categories extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
  };

  state = {
    data: [],
    download: {
      needToDownloadSoundEffects: false,
      progress: 0,
    },
  };

  componentWillMount() {
    // this.init();
    // this.handleDownLoad();
    // console.log(IDENTITY_KEY_NAME.TOKEN, getIdentity, VERSION_NAME, greaterAndEqualThan);
    const timer = setInterval(async () => {
      const token = getIdentity(IDENTITY_KEY_NAME.TOKEN, undefined);
      if (token) {
        clearInterval(timer);
        const isDownload = await greaterAndEqualThan(VERSION_NAME.LIBRARY_SOUND_EFFECT);
        this.setState({
          download: {
            progress: 0,
            needToDownloadSoundEffects: OS.TYPE !== DEVICE.PC && isDownload,
          },
        }, () => {
          this.state.download.needToDownloadSoundEffects
            ? window.onfire.on('setDownloadSoundsProgress', ({ progress }) => {
              this.setProgress(progress);
            })
            : this.init();
          this.handleDownLoad();
        });
      }
    }, 100);
  }

  componentWillUnmount() {
    window.onfire.off('setDownloadSoundsProgress');
  }

  init = () => {
    this.hideDownload();
    this.getCategories();
    // setTimeout(this.getCategories, 0);
  };

  setProgress = (progress) => {
    progress === 100
      ? this.init()
      : this.setDownloadProgress(progress);
  };

  setDownloadProgress = (progress) => {
    this.setState(({ download }) => ({
      download: { ...download, progress },
    }));
  };

  getCategories = async () => {
    const { code, data, msg } = await category.list();
    if (code !== 200) {
      console.log(msg);
      return;
    }
    const s3 = data.filter(item => item.name.toLowerCase() === 's3')[0];
    let filteredData = data;
    if (s3) {
      filteredData = data.map((item) => {
        if (item.name.toLowerCase() === 's2') {
          item.id2 = s3.id;
          item.canEnter = item.canEnter || s3.canEnter;
        }
        return item;
      });
    }
    this.setState({ data: filteredData });
  };

  routeAfterAnimation = ({ id, id2, name: theme }) => {
    setTimeout(() => {
      this.props.history.push(`/stage/${theme}/${id}/${id2 || ''}`);
    }, 300);
  };

  goBack = () => {
    callNativeFunction(nativeFunction.BACK)();
  };

  hideDownload = () => {
    this.setState(({ download }) => ({
      download: { ...download, needToDownloadSoundEffects: false },
    }));
  };

  handleDownLoad = () => {
    OS.TYPE !== DEVICE.PC && callNativeFunction(nativeFunction.CHECK_LOCAL_SOUNDS)({
      path: soundsPath,
      size: 1494818,
    });
  };

  render = () => (
    <div className="stage-entrance-container">
      {this.state.download.needToDownloadSoundEffects
      && this.state.download.progress !== 0 && this.state.download.progress !== 100
        ? (
          <DownLoad
            progress={this.state.download.progress}
            callback={this.handleDownLoad}
          />
        )
        : null
      }
      <div className="stage-entrance-wrapper">
        <div className="quit" onClick={this.goBack} />
        {this.state.data.map((item) => {
          const name = item.name.toLowerCase();
          return (name !== 's3'
            && (
              <div
                className={`clickable ${name}${item.canEnter ? '' : ' disabled'}`}
                key={item.name}
                onClick={() => { this.routeAfterAnimation(item); }}
                onTouchStart={() => {}}
              />
            )
          );
        })}
        <div className="prek" />
      </div>
    </div>
  );
}

export default Categories;
